import { MAIN_COLOR } from "@/utils/constants";
import { useTheme } from "next-themes";
import { VerticalTimelineElement } from "react-vertical-timeline-component";
import { TExperienceData } from "./Experience";
import ExperienceIcon from "./ExperienceIcon";
import ExperienceTechs from "./ExperienceTechs";
import ExperienceDesc from "./ExperienceDesc";
import ExperienceHeader from "./ExperienceHeader";
import { useEffect, useState } from "react";
import { useTranslations } from "next-intl";

const ExperienceItem = ({
  jobTitle,
  company,
  startDate,
  endDate,
  companyLocation,
  workModel,
  jobType,
  description,
  techs,
  icon,
  lang,
}: Partial<TExperienceData> & { lang: string }) => {
  const { resolvedTheme: isDark } = useTheme();
  const [mount, setMount] = useState(false);
  const t = useTranslations();

  useEffect(() => setMount(true), []);

  const contentStyle = {
    background: isDark === "dark" ? "rgba(255,255,255,0.1)" : "#f5f5f5",
    color: isDark === "dark" ? "#fff" : "#000",
    boxShadow:
      "0 10px 15px -3px rgba(0,0,0,0.1), 0 4px 6px -4px rgba(0,0,0,0.1)",
    backdropFilter: isDark === "dark" ? "blur(10px)" : "none",
  };

  const contentArrowStyle = {
    borderRight:
      isDark === "dark"
        ? "13px solid rgba(255,255,255,0.1)"
        : "13px solid   #f5f5f5",
  };

  const iconStyle = {
    background: MAIN_COLOR,
    outline: `3px solid ${MAIN_COLOR}`,
    border: "none !important",
    boxShadow: "none",
    color: "#fff !important",
  };

  if (!mount) return null;

  return (
    <VerticalTimelineElement
      style={{ animationDelay: "0.3s" }}
      className="vertical-timeline-element--work"
      contentStyle={contentStyle}
      contentArrowStyle={lang === "ar" ? {} : contentArrowStyle}
      date={`${startDate} - ${endDate === "Present" ? t("Present") : endDate}`}
      iconStyle={iconStyle}
      icon={<ExperienceIcon icon={icon} company={company} />}
      shadowSize="medium"
      animateOnScroll="fadeIn"
    >
      <ExperienceHeader
        jobTitle={jobTitle}
        company={company}
        companyLocation={companyLocation}
        jobType={jobType}
        workModel={workModel}
      />
      <ExperienceDesc description={description} />
      <ExperienceTechs techs={techs} />
    </VerticalTimelineElement>
  );
};

export default ExperienceItem;
